import React, { useState } from 'react';
import Icon from '../AppIcon';
import Select from './Select';
import Button from './Button';
import CrmMailQuotaShell from '../crm/CrmMailQuotaShell';

const FilterPanel = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [dateRange, setDateRange] = useState('7days');
  const [team, setTeam] = useState('all');
  const [status, setStatus] = useState('all');
  const [priority, setPriority] = useState('all');

  const dateRangeOptions = [
    { value: 'today', label: "Aujourd\'hui" },
    { value: '7days', label: '7 derniers jours' },
    { value: '30days', label: '30 derniers jours' },
    { value: '90days', label: '90 derniers jours' },
    { value: 'custom', label: 'Personnalisé' }
  ];

  const teamOptions = [
    { value: 'all', label: 'Toutes les équipes' },
    { value: 'sales-north', label: 'Ventes Nord' },
    { value: 'sales-south', label: 'Ventes Sud' },
    { value: 'sales-east', label: 'Ventes Est' },
    { value: 'sales-west', label: 'Ventes Ouest' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'active', label: 'Actif' },
    { value: 'pending', label: 'En attente' },
    { value: 'closed', label: 'Fermé' },
    { value: 'lost', label: 'Perdu' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'Toutes les priorités' },
    { value: 'high', label: 'Haute' },
    { value: 'medium', label: 'Moyenne' },
    { value: 'low', label: 'Basse' }
  ];

  const togglePanel = () => {
    setIsExpanded(!isExpanded);
  };

  const handleReset = () => {
    setDateRange('7days');
    setTeam('all');
    setStatus('all');
    setPriority('all');
  };

  const handleApply = () => {
    setIsExpanded(false);
  };

  return (
    <div className="filter-panel">
      <CrmMailQuotaShell />

      {isExpanded && (
        <div className="filter-panel-content">
          <div className="filter-group">
            <label className="filter-label">Période</label>
            <Select
              options={dateRangeOptions}
              value={dateRange}
              onChange={setDateRange}
              placeholder="Sélectionner une période"
            />
          </div>

          <div className="filter-group">
            <label className="filter-label">Équipe</label>
            <Select
              options={teamOptions}
              value={team}
              onChange={setTeam}
              placeholder="Sélectionner une équipe"
            />
          </div>

          <div className="filter-group">
            <label className="filter-label">Statut</label>
            <Select
              options={statusOptions}
              value={status}
              onChange={setStatus}
              placeholder="Sélectionner un statut"
            />
          </div>

          <div className="filter-group">
            <label className="filter-label">Priorité</label>
            <Select
              options={priorityOptions}
              value={priority}
              onChange={setPriority}
              placeholder="Sélectionner une priorité"
            />
          </div>

          <div className="filter-group lg:col-span-4 flex items-end gap-3 justify-end">
            <Button
              variant="outline"
              onClick={handleReset}
              iconName="RotateCcw"
              iconPosition="left"
            >
              Réinitialiser
            </Button>
            <Button
              variant="default"
              onClick={handleApply}
              iconName="Check"
              iconPosition="left"
            >
              Appliquer
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;